<div class="demo-container">
    <!-- Header -->
    <div class="header">
        <h1>Confirmation Modal</h1>
        <p class="subtitle">Ejemplos interactivos del ConfirmationService</p>
    </div>

    <!-- Result Badge -->
    <div class="result-badge" *ngIf="lastAction !== 'Ninguna acción ejecutada aún'">
        <mat-icon>{{ lastAction.includes('✅') ? 'check_circle' : 'cancel' }}</mat-icon>
        <span [innerHTML]="lastAction"></span>
    </div>

    <!-- Common Use Cases -->
    <section class="section">
        <h2>Casos de Uso Comunes</h2>
        
        <div class="examples-grid">
            <!-- Delete -->
            <div class="example-card danger" (click)="testDelete()">
                <mat-icon>delete</mat-icon>
                <div class="content">
                    <h3>Eliminar</h3>
                    <p>Confirmar eliminación de registros</p>
                </div>
            </div>

            <!-- Save -->
            <div class="example-card primary" (click)="testSave()">
                <mat-icon>save</mat-icon>
                <div class="content">
                    <h3>Guardar</h3>
                    <p>Confirmar guardado de cambios</p>
                </div>
            </div>

            <!-- Discard -->
            <div class="example-card warning" (click)="testDiscard()">
                <mat-icon>warning</mat-icon>
                <div class="content">
                    <h3>Descartar</h3>
                    <p>Descartar cambios sin guardar</p>
                </div>
            </div>

            <!-- Anular -->
            <div class="example-card warning" (click)="testAnular()">
                <mat-icon>cancel</mat-icon>
                <div class="content">
                    <h3>Anular</h3>
                    <p>Anular documentos o registros</p>
                </div>
            </div>

            <!-- Export -->
            <div class="example-card primary" (click)="testExport()">
                <mat-icon>file_download</mat-icon>
                <div class="content">
                    <h3>Exportar</h3>
                    <p>Confirmar exportación de datos</p>
                </div>
            </div>

            <!-- Send Notification -->
            <div class="example-card primary" (click)="testSendNotification()">
                <mat-icon>email</mat-icon>
                <div class="content">
                    <h3>Notificar</h3>
                    <p>Enviar notificaciones masivas</p>
                </div>
            </div>

            <!-- Logout -->
            <div class="example-card" (click)="testLogout()">
                <mat-icon>logout</mat-icon>
                <div class="content">
                    <h3>Cerrar Sesión</h3>
                    <p>Confirmar cierre de sesión</p>
                </div>
            </div>

            <!-- Reset -->
            <div class="example-card danger" (click)="testReset()">
                <mat-icon>restore</mat-icon>
                <div class="content">
                    <h3>Restaurar</h3>
                    <p>Restaurar valores por defecto</p>
                </div>
            </div>

            <!-- Batch Process -->
            <div class="example-card primary" (click)="testBatchProcess()">
                <mat-icon>play_arrow</mat-icon>
                <div class="content">
                    <h3>Procesar Lote</h3>
                    <p>Procesamiento masivo de datos</p>
                </div>
            </div>
        </div>
    </section>

    <!-- Toggle Actions -->
    <section class="section">
        <h2>Activar / Desactivar</h2>
        
        <div class="examples-grid small">
            <!-- Activate -->
            <div class="example-card success" (click)="testActivate()">
                <mat-icon>check_circle</mat-icon>
                <div class="content">
                    <h3>Activar</h3>
                    <p>Activar elemento</p>
                </div>
            </div>

            <!-- Deactivate -->
            <div class="example-card warning" (click)="testDeactivate()">
                <mat-icon>cancel</mat-icon>
                <div class="content">
                    <h3>Desactivar</h3>
                    <p>Desactivar elemento</p>
                </div>
            </div>
        </div>
    </section>

    <!-- Informational Modals -->
    <section class="section">
        <h2>Modales Informativos</h2>
        
        <div class="examples-grid small">
            <!-- Warning -->
            <div class="example-card warning" (click)="testWarning()">
                <mat-icon>warning</mat-icon>
                <div class="content">
                    <h3>Advertencia</h3>
                    <p>Mostrar advertencias</p>
                </div>
            </div>

            <!-- Info -->
            <div class="example-card info" (click)="testInfo()">
                <mat-icon>info</mat-icon>
                <div class="content">
                    <h3>Información</h3>
                    <p>Mostrar información</p>
                </div>
            </div>
        </div>
    </section>

    <!-- Type System Examples -->
    <section class="section">
        <h2>Ejemplos de Tipos (ConfirmationModalType)</h2>
        
        <div class="examples-grid">
            <!-- Type: SUCCESS -->
            <div class="example-card success" (click)="testSuccessType()">
                <mat-icon>check_circle</mat-icon>
                <div class="content">
                    <h3>Tipo SUCCESS</h3>
                    <p>🟢 Círculo verde, botón verde</p>
                </div>
            </div>

            <!-- Type: WARNING -->
            <div class="example-card warning" (click)="testWarningType()">
                <mat-icon>report_problem</mat-icon>
                <div class="content">
                    <h3>Tipo WARNING</h3>
                    <p>🟠 Círculo naranja, botón naranja</p>
                </div>
            </div>

            <!-- Type: DANGER -->
            <div class="example-card danger" (click)="testCustomDanger()">
                <mat-icon>warning</mat-icon>
                <div class="content">
                    <h3>Tipo DANGER</h3>
                    <p>🔴 Círculo rojo, botón rojo</p>
                </div>
            </div>

            <!-- Type: INFO -->
            <div class="example-card info" (click)="testInfoType()">
                <mat-icon>info</mat-icon>
                <div class="content">
                    <h3>Tipo INFO</h3>
                    <p>🔵 Círculo azul, botón azul</p>
                </div>
            </div>

            <!-- Type: DEFAULT -->
            <div class="example-card" (click)="testDefaultType()">
                <mat-icon>help_outline</mat-icon>
                <div class="content">
                    <h3>Tipo DEFAULT</h3>
                    <p>⚪ Círculo gris, botón azul</p>
                </div>
            </div>
        </div>
    </section>

    <!-- Custom Configurations -->
    <section class="section">
        <h2>Configuraciones Personalizadas</h2>
        
        <div class="examples-grid small">
            <!-- Custom Width -->
            <div class="example-card primary" (click)="testCustomWidth()">
                <mat-icon>aspect_ratio</mat-icon>
                <div class="content">
                    <h3>Ancho Personalizado</h3>
                    <p>Modal con customWidth: 600px</p>
                </div>
            </div>

            <!-- HTML Content -->
            <div class="example-card primary" (click)="testHtmlContent()">
                <mat-icon>code</mat-icon>
                <div class="content">
                    <h3>HTML Enriquecido</h3>
                    <p>Contenido con formato HTML</p>
                </div>
            </div>

            <!-- No Icon -->
            <div class="example-card" (click)="testNoIcon()">
                <mat-icon>remove_circle_outline</mat-icon>
                <div class="content">
                    <h3>Sin Ícono</h3>
                    <p>Modal simple sin ícono</p>
                </div>
            </div>
        </div>
    </section>

    <!-- Info Footer -->
    <div class="info-footer">
        <mat-icon>lightbulb</mat-icon>
        <div>
            <strong>Tip:</strong> Haz clic en cualquier card para ver el modal en acción. 
            Todos los ejemplos usan el mismo componente con diferentes configuraciones.
        </div>
    </div>
</div>

